module.exports = __webpack_public_path__ + "img/Boomfest.a5a1543d.png";